const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:3000",
  VERSION: process.env.REACT_APP_API_VERSION || "v1",
  TIMEOUT: 30000,

  get FULL_BASE_URL() {
    const fullUrl = `${this.BASE_URL}/${this.VERSION}`;
    return fullUrl;
  },
};

export const STORAGE_KEYS = {
  AUTH_USER: "authUser",
  ACCESS_TOKEN: "accessToken",
  USER_PREFERENCES: "userPreferences",
};

export const REQUEST_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export default API_CONFIG;
